// @flow

import type { IConfirmationResult } from '../contracts';

export default class ConfirmationResult
	implements IConfirmationResult {
	constructor (status: string) {
		this.status = status;
	}
}